import React from "react";
import "./CommonStyle.css";

const RichTextSection = () => {
  return (
    <section className="richtext-section">
      <div className="richtext-wrapper text-center">
        <div className="richtext-content">
          <h2 className="richtext-title">The Essence of SALENE</h2>
          <div className="richtext-body">
            <p>
              Crafting Fragrances that Embody Strength and Elegance in Every
              Moment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RichTextSection;
